// Import
import _ from 'lodash';

function parseFloatOrString(s, divider = 1) {
    if (_.isNumber(s)) return s / divider;
    s = s.replace(/,/g, '');
    if (s.match(/^[0-9]+\.0+$/)) {
        if (divider === 1) return s;
        return parseFloat(s) / divider;
    }
    if (s.match(/^[0-9]+\.[0-9]+$/)) return parseFloat(s) / divider;
    if (s.match(/^[0-9]+$/)) return parseFloat(s) / divider;
    return s;
}

function multiplyIfFloat(v, mult) {
    if (_.isNumber(v)) return v * mult;
    return v;
}


export { parseFloatOrString, multiplyIfFloat };
